import styled from 'styled-components';

import { Text } from '~/components/ui/Text';

const StyledInput = styled.input<{ $active?: boolean }>`
	width: 100%;
	border-radius: 10px;
	background-color: ${(props) =>
		props.$active ? '#2D70DA' : 'rgba(255, 255, 255, 0.05)'};
	padding: 19px 60px 18px 20px;
	border: 0;

	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;

	transition: all 0.3s ease;

	&:focus {
		outline: none;
	}
`;

const StyledIcon = styled.img`
	transition: filter 0.3s ease;
	pointer-events: none;
`;

const StyledTextLabel = styled(Text)`
	color: #ffffff;
	font-weight: 400;
	font-size: 16px;
	transition: filter 0.3s ease;

	span:first-child {
		font-size: 16px;
	}

	span:last-child {
		font-size: 16px;
		opacity: 0.5;
	}
`;

const StyledDaysLabel = styled(Text)`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	color: #ffffff;
	font-size: 16px;
	font-weight: 400;
	opacity: 0.5;
	transition: color 0.3s ease;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	column-gap: 10px;
`;

const StyledContainer = styled.div`
	position: relative;

	&:hover,
	&:active,
	&:focus {
		${StyledInput} {
			background-color: rgba(255, 255, 255, 1);
			color: #000000;
		}

		${StyledDaysLabel} {
			color: #000000;
		}

		${StyledRightContainer} {
			${StyledIcon},
			${StyledTextLabel} {
				filter: invert(100%);
			}
		}
	}
`;

export {
	StyledContainer,
	StyledDaysLabel,
	StyledIcon,
	StyledInput,
	StyledRightContainer,
	StyledTextLabel,
};
